// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreviewActionsPanel__container-ecfc3a {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 16px;
  margin-top: auto;
}

.PreviewActionsPanel__button-container-e55c71 {
  margin-inline-end: 24px;
  position: relative;
}

.PreviewActionsPanel__button-container-e55c71:last-child {
  margin-inline-end: 0;
}

.PreviewActionsPanel__ic-check-d0a220 {
  margin-inline-start: 8px;
}

.PreviewActionsPanel__menu-title-da4555 {
  font: var(--font-body-4);
  color: var(--addition-50_50);
  letter-spacing: var(--font-spacing-body-4);
}

.PreviewActionsPanel__menu-title-da4555:hover,
.PreviewActionsPanel__menu-title-da4555:focus,
.PreviewActionsPanel__menu-title-da4555:active {
  background-color: transparent;
}

.PreviewActionsPanel__audio-menu-title-fc8868 {
  margin-top: 8px;
}

.PreviewActionsPanel__background-panel-delimeter-af3553 {
  border-top: 1px solid var(--addition-50_10);
  margin: 8px 16px;
  max-width: calc(100% - 32px);
  min-height: 0;
  cursor: initial;
}

.PreviewActionsPanel__warning-icon-e4ca3f {
  position: absolute;
  top: -6px;
  right: -6px;
}

.PreviewActionsPanel__popover-c4e616 {
  background-color: var(--light-10-addition-120);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/components/RoomCallPreviewVideo/PreviewActionsPanel/PreviewActionsPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,wBAAA;EACA,4BAAA;EACA,0CAAA;AACF;;AAEA;;;EAGE,6BAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,2CAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AACF;;AAGA;EACE,8CAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  margin-bottom: 16px;\n  margin-top: auto;\n}\n\n.button-container {\n  margin-inline-end: 24px;\n  position: relative;\n}\n\n.button-container:last-child {\n  margin-inline-end: 0;\n}\n\n.ic-check {\n  margin-inline-start: 8px;\n}\n\n.menu-title {\n  font: var(--font-body-4);\n  color: var(--addition-50_50);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.menu-title:hover,\n.menu-title:focus,\n.menu-title:active {\n  background-color: transparent;\n}\n\n.audio-menu-title {\n  margin-top: 8px;\n}\n\n.background-panel-delimeter {\n  border-top: 1px solid var(--addition-50_10);\n  margin: 8px 16px;\n  max-width: calc(100% - 32px);\n  min-height: 0;\n  cursor: initial;\n}\n\n.warning-icon {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n}\n\n\n.popover {\n  background-color: var(--light-10-addition-120);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PreviewActionsPanel__container-ecfc3a`,
	"button-container": `PreviewActionsPanel__button-container-e55c71`,
	"buttonContainer": `PreviewActionsPanel__button-container-e55c71`,
	"ic-check": `PreviewActionsPanel__ic-check-d0a220`,
	"icCheck": `PreviewActionsPanel__ic-check-d0a220`,
	"menu-title": `PreviewActionsPanel__menu-title-da4555`,
	"menuTitle": `PreviewActionsPanel__menu-title-da4555`,
	"audio-menu-title": `PreviewActionsPanel__audio-menu-title-fc8868`,
	"audioMenuTitle": `PreviewActionsPanel__audio-menu-title-fc8868`,
	"background-panel-delimeter": `PreviewActionsPanel__background-panel-delimeter-af3553`,
	"backgroundPanelDelimeter": `PreviewActionsPanel__background-panel-delimeter-af3553`,
	"warning-icon": `PreviewActionsPanel__warning-icon-e4ca3f`,
	"warningIcon": `PreviewActionsPanel__warning-icon-e4ca3f`,
	"popover": `PreviewActionsPanel__popover-c4e616`
};
module.exports = ___CSS_LOADER_EXPORT___;
